import AntdDrawer, { DrawerProps as AntdDrawerProps } from "antd/es/drawer";

export type DrawerProps = AntdDrawerProps;

const Drawer = AntdDrawer;

export { Drawer };
